/* eslint-disable max-len */
import _ from 'underscore';
import { AgeRanges, Genders } from '@bingads-webui-campaign-react/audience-demographic';

const ROOT = 'root';

export const getInterestNames = (name = '') => {
  if (typeof name !== 'string') {
    return { isValid: false };
  }

  const levels = name.split('/');

  // Name might start with "/", so the first element of levels might be empty string
  if (levels[0] === '') {
    levels.shift();
  }

  // If there are only one element after split, then it is a leaf node
  if (levels.length === 1) {
    return {
      name: `${ROOT}/${levels[0]}`,
      parent: undefined,
      isValid: true,
    };
  }

  // If there are more than one element after split, pick up the parent node and leaf node
  if (levels.length > 1) {
    return {
      name: `${levels[0]}/${levels[levels.length - 1]}`,
      parent: levels[0],
      isValid: true,
    };
  }

  return { isValid: false };
};

export const getAudienceValue = (name = '') => {
  const array = name.split('/');
  return array[array.length - 1];
};

export const formatAudienceListToFlatTree = (audiences = []) => {
  const hierarchy = {
    root: [],
  };
  const valueToAudience = {};
  const valueToFlatItem = {};

  audiences.forEach((audience) => {
    const {
      Reach, Name, Description, Id,
    } = audience;
    // The name includes parent value to avoid the a certain value is both child and parent, this will make Tree structure incorrect.
    // For example, "Food" is parent node and contains 6 children, it's also the child for "Food & Groceries"
    const { name, parent, isValid } = getInterestNames(Name);

    if (!isValid) {
      return;
    }

    const structure = {
      value: name,
      content: name,
      parentValue: parent,
      allowedCheck: true,
      showTips: true,
      description: Description,
      reachEstimation: Reach,
      id: Id,
    };

    if (parent === undefined) {
      hierarchy.root.push(structure);
    } else {
      if (!hierarchy[parent]) {
        hierarchy[parent] = [];
      }

      hierarchy[parent].push(structure);
    }

    valueToAudience[name] = audience;
    valueToFlatItem[name] = structure;
  });

  const formattedItems = [];
  Object.keys(hierarchy).forEach((parent) => {
    if (parent !== 'root') {
      // Push parent first
      formattedItems.push({
        value: parent,
        content: parent,
        allowedCheck: false,
        showTips: false,
      });
      // Push all children
      formattedItems.push(...hierarchy[parent]);
    } else {
      formattedItems.push(...hierarchy[parent]);
    }
  });

  return [formattedItems, valueToAudience, valueToFlatItem];
};

export const dimensionFormatter = {
  ageRanges: ageRanges => (_.isEmpty(ageRanges) ? _.keys(AgeRanges) : ageRanges),
  genderTypes: genderTypes => (_.isEmpty(genderTypes) ? _.keys(Genders) : genderTypes),
};

export const modelToViewModelForAudienceGroup = (audienceGroupModel) => {
  const audiences = _.chain(audienceGroupModel)
    .result('Dimensions', [])
    .filter(dimension => dimension.Type === 'Audience')
    .map(dimension => _.result(dimension, 'Audiences'))
    .flatten()
    .compact();

  // Leave for later features
  // const customerData = audiences
  //   .filter(audience => audience.Type !== 'InMarket')
  //   .value();

  const interests = audiences
    .filter(audience => audience.Type === 'InMarket')
    .map(audience => getInterestNames(audience.Name).name)
    .value();

  const ageRanges = _.chain(audienceGroupModel)
    .result('Dimensions', [])
    .filter(dimension => dimension.Type === 'Age')
    .first()
    .result('AgeRanges')
    .value();

  const genderTypes = _.chain(audienceGroupModel)
    .result('Dimensions', [])
    .filter(dimension => dimension.Type === 'Gender')
    .first()
    .result('GenderTypes')
    .value();

  return {
    interests,
    ageRanges: dimensionFormatter.ageRanges(ageRanges),
    genderTypes: dimensionFormatter.genderTypes(genderTypes),
  };
};
